import {Client, ClientAPIInterface, ClientInterface} from "@/entity/Client";

export interface UserAPIInterface {
  id: number;
  email: string;
  roles: string[];
  lastName: string;
  firstName: string;
  client: ClientAPIInterface | string;
}

export interface UserInterface {
  id: number | undefined;
  email: string | undefined;
  roles: string[] | undefined;
  password: string | undefined;
  lastName: string | undefined;
  firstName: string | undefined;
  client: ClientInterface | string | undefined;
}

export class User {
  public id: number | undefined;
  public email: string | undefined;
  public roles: string[] | undefined;
  public password: string | undefined;
  public lastName: string | undefined;
  public firstName: string | undefined;
  public client: Client | string | undefined;

  constructor(user: UserInterface | undefined = undefined) {
    this.id = user?.id ? user.id : undefined;
    this.email = user?.email ? user.email : undefined;
    this.roles = user?.roles ? user.roles : undefined;
    this.password = user?.password ? user.password : undefined;
    this.lastName = user?.lastName ? user.lastName : undefined;
    this.firstName = user?.firstName ? user.firstName : undefined;
    this.client = user?.client ? user.client : undefined;
  }
}
